'use strict';

exports.__esModule = true;
exports.default = flattenErrorsObject;

var _lodash = require('lodash.values');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.flatten');

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function flattenErrorsObject(obj) {
  if (typeof obj === 'string') {
    return obj;
  }

  return (0, _lodash4.default)((0, _lodash2.default)(obj).map(function (value) {
    if (typeof obj !== 'string') {
      return flattenErrorsObject(value);
    }
    return value;
  }));
}